import React, { createContext } from "react"
import { RadioGroup } from "@blueprintjs/core"
import { withFormController } from "../Molecules/FormController"

const CustomRadioGroup = ({
  value,
  className,
  disabled,
  path,
  onChange,
  children,
  inline,
}) => {
  const handleSelect = id => {
    onChange(path, id)
  }

  return (
    <RadioGroup disabled={disabled} className={className} inline={inline}>
      <RadioGroupContext.Provider
        value={{ path, value, onSelect: handleSelect }}
      >
        {children}
      </RadioGroupContext.Provider>
    </RadioGroup>
  )
}
export default withFormController(CustomRadioGroup)
export const RadioGroupContext = createContext()
